import { useI18n } from '@/lib/i18n';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import logo from '@/assets/kostya_logo.svg';
import { Send, Instagram, Youtube, Linkedin } from 'lucide-react';

const BehanceIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M22 7h-7V2H9v5H2v15h20V7zM10 3h4v4h-4V3zm8 18H6V8h12v13zm-5-9.5a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const defaultSocials = {
  telegram: 'https://t.me/',
  instagram: 'https://instagram.com/',
  behance: 'https://behance.net/',
  youtube: 'https://youtube.com/',
  linkedin: 'https://linkedin.com/',
};

const Footer = () => {
  const { lang, t } = useI18n();
  const year = new Date().getFullYear();

  const { data: settings } = useQuery({
    queryKey: ['site-settings'],
    queryFn: async () => {
      const { data } = await supabase.from('site_settings').select('*').maybeSingle();
      return data;
    },
  });

  const role = lang === 'ru'
    ? (settings?.footer_role_ru) || 'Креативный арт-директор'
    : (settings?.footer_role_en) || 'Creative Art Director';

  const socials = (settings?.footer_socials as any) || defaultSocials;

  const socialLinks = [
    { icon: Send, href: socials.telegram || '', label: 'Telegram' },
    { icon: Instagram, href: socials.instagram || '', label: 'Instagram' },
    { icon: BehanceIcon, href: socials.behance || '', label: 'Behance' },
    { icon: Youtube, href: socials.youtube || '', label: 'YouTube' },
    { icon: Linkedin, href: socials.linkedin || '', label: 'LinkedIn' },
  ].filter(s => s.href);

  return (
    <footer className="py-16 md:py-24 border-t border-border/50">
      <div className="container flex flex-col items-center text-center gap-6">
        <img src={logo} alt="Kostya Kot" className="h-14 md:h-16" />
        <p className="text-muted-foreground text-sm tracking-[0.2em] uppercase">
          {role}
        </p>

        <div className="flex items-center gap-4 mt-2">
          {socialLinks.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="w-10 h-10 rounded-full border border-border/50 flex items-center justify-center text-muted-foreground hover:text-[#9aff03] hover:border-[#9aff03] transition-colors"
            >
              <s.icon size={18} />
            </a>
          ))}
        </div>

        <p className="text-xs text-muted-foreground mt-4">
          © {year}. {t('Все права защищены', 'All rights reserved')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
